import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericResponse } from 'src/app/core/models/generic-response.model';
import { GlobalComponent } from 'src/app/global-component';
import { GenericActivarInactivarEntidadRequest } from '../models/generic-entities.model';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private urlService = 'common/';

  constructor(private http: HttpClient) { }

  activarInactivarRegistro(planTrabajo: GenericActivarInactivarEntidadRequest) {
    return this.http.post<GenericResponse<boolean>>(`${GlobalComponent.API_URL}${this.urlService}activar-inactivar`, planTrabajo, { reportProgress: true, observe: "events" });
  }

}
